import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import FilterIcon from '@mui/icons-material/TuneOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import GenericDrawer from '@/components/GenericDrawer';
import { AgaveDataGrid } from '@/components/GenericTable/DataGridStyled';
import SearchInput from '@/components/SearchInput';

import { batchesColumns } from './dependencies/batches-columns';
import Filters from './dependencies/Filters';
import { filters } from './dependencies/utils';
import { useBatches } from './useBatches';

const BatchesSection = () => {
  const hooks = useBatches();
  const theme = useTheme();

  return (
    <Paper elevation={3} sx={{ padding: `${theme.spacing(2)} 0 0` }}>
      <Box
        sx={{
          padding: `0 ${theme.spacing(4)}`,
          flexDirection: { xxs: 'column', xl: 'row' },
          gap: { xxs: '1rem', xl: 0 },
          alignItems: 'center',
          mb: 2,
        }}
        display="flex"
        justifyContent="space-between"
        width="100%"
        height="auto"
      >
        <SearchInput
          placeholder="Buscar por lote, SKU o producto..."
          buttonText="Buscar"
          handleKeyPress={hooks.handleKeyPress}
          onChange={hooks.onChgSearch}
          onClick={hooks.onSearch}
          sx={{ width: '100%', maxWidth: '500px' }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xxs: 'column', xs: 'row' },
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.25rem',
          }}
        >
          <Box
            display="flex"
            gap="0.5rem"
            alignItems="center"
            justifyContent="center"
            sx={{
              cursor: 'pointer',
              ':hover': { backgroundColor: theme.palette.primary.lighter },
              padding: '0.5rem',
              borderRadius: '1rem',
            }}
            onClick={hooks.handleOpenDrawer}
          >
            <FilterIcon color="primary" />
            <Typography variant="body1" fontWeight={theme.typography.fontWeightMedium}>
              Filtros
            </Typography>
          </Box>

          <Button
            onClick={hooks.downloadReport}
            variant="text"
            size="small"
            startIcon={<CloudDownloadOutlinedIcon color="primary" />}
          >
            Descargar reporte
          </Button>
        </Box>
      </Box>

      <Box sx={{ overflowX: 'auto', width: '100%' }}>
        <Box sx={{ minWidth: '900px' }}>
          <AgaveDataGrid
            columns={batchesColumns()}
            rows={hooks.batches.data}
            loading={hooks.batches.loading}
            localeText={{
              noRowsLabel: hooks.hasActiveFilters()
                ? 'No encontramos ningún lote que coincida con tu búsqueda o filtros.'
                : 'No hay lotes de inventario disponibles',
            }}
            rowCount={hooks.batches.totalRows}
            disableRowSelectionOnClick={true}
            disableCursorPointer={true}
            getRowId={(row) => row.id}
            hideFooterSelectedRowCount={true}
            paginationModel={{
              page: hooks.page,
              pageSize: hooks.pageSize,
            }}
            onPaginationModelChange={(model) => {
              hooks.setPage(model.page);
              hooks.setPageSize(model.pageSize);
            }}
            disableColumnMenu={true}
            paginationMode="server"
          />
        </Box>
      </Box>

      <GenericDrawer
        open={hooks.openDrawer}
        onClose={hooks.handleCloseDrawer}
        title="Filtros"
        disableEscapeKeyDown={true}
        iconTitle={<FilterIcon color="primary" />}
      >
        <Filters
          filters={filters}
          selectedFilters={hooks.filtersState}
          onChange={hooks.onChangeFilter}
          clearFilters={hooks.clearFilters}
          applyFilters={hooks.applyFilters}
        />
      </GenericDrawer>
    </Paper>
  );
};

export default BatchesSection;
